<template>
  <div class="ActivityDiscount">
    <div class='titlebg'>
      <img  class="bg" :src="imgUrl1" alt=""  >
    </div>
    <div class="btn btn1">
      <!-- <div @click="getActivityDiscount(2)"></div> -->
    </div>
    <!-- <div class="btn btn2">
      <div @click="getActivityDiscount(2)"></div>
    </div> -->
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'dragon',
  data(){
    return {
      imgUrl1: 'https://cms.dafang24.com/aliapp/2021/lowcontent.png',
    }
  },
  created () {},
  mounted () {},
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      div {
        display: inline-block;
        /*background-color: rgba(0,0,0, .5);*/
      }
    }
    .btn1 {
      top: 1330px;
      div {
        width: 400px;
        height: 120px;
      }
    }
    .btn2  {
      top: 2760px;
      div {
        width: 600px;
        height: 120px;
      }
    }
  }
  .titlebg{
        position: relative;
    }        
  .titlebg .bg{
        width:100%;
        height:100%;
    }   
  .titlebg .btns{
        position: absolute;
        top:1670px;
        left:220px;
        width:300px;
        height:70px;
        background:rgba(255,250,186,1);
        opacity:1;
        border-radius:36px;
        line-height: 70px;
        text-align: center;
        font-size:25px;
        color:rgba(4,108,102,1);
    } 
    
</style>